// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Box } from 'grommet'
import { HelpOption } from 'grommet-icons'

import { HelpNavContent } from './HelpNavContent'

const HelpMenu = {
  id: 1,
  label: 'Help menu',
  icon: (
    <Box
      data-testid="btn-help"
      round
      height="36px"
      width="36px"
      align="center"
      justify="center"
    >
      <HelpOption color="text-strong" />
    </Box>
  ),
  content: <HelpNavContent />
}

export { HelpMenu }
